import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/ServiceDetailPage.css';

const MantenimientoPage = () => {
  const subServices = [
    {
      title: 'Mantenimiento Preventivo',
      description: 'Programas de mantenimiento planificado para evitar fallas y prolongar la vida útil de sus instalaciones.',
      features: [
        'Inspecciones periódicas programadas',
        'Mantenimiento de sistemas eléctricos',
        'Mantenimiento de sistemas de climatización',
        'Mantenimiento de sistemas hidráulicos',
        'Reportes detallados de estado'
      ]
    },
    {
      title: 'Mantenimiento Correctivo',
      description: 'Respuesta rápida y efectiva ante fallas y averías en sus instalaciones.',
      features: [
        'Servicio de emergencia 24/7',
        'Reparaciones inmediatas',
        'Diagnóstico técnico especializado',
        'Repuestos y materiales de calidad',
        'Garantía de trabajos realizados'
      ]
    },
    {
      title: 'Ingeniería de Instalaciones',
      description: 'Diseño, implementación y optimización de sistemas e instalaciones técnicas.',
      features: [
        'Diseño de sistemas técnicos',
        'Instalaciones eléctricas industriales',
        'Automatización y control',
        'Optimización energética',
        'Proyectos llave en mano'
      ]
    },
    {
      title: 'Mantenimiento de Edificios',
      description: 'Cuidado integral de infraestructura corporativa y edificios comerciales.',
      features: [
        'Mantenimiento de fachadas',
        'Sistemas de seguridad',
        'Ascensores y montacargas',
        'Sistemas contra incendios',
        'Infraestructura general'
      ]
    },
    {
      title: 'Gestión de Activos',
      description: 'Administración y control del ciclo de vida de los activos de su empresa.',
      features: [
        'Inventario de activos',
        'Planificación de mantenimiento',
        'Gestión de repuestos',
        'Control de costos',
        'Histórico de intervenciones'
      ]
    },
    {
      title: 'Servicios Especializados',
      description: 'Soluciones técnicas específicas para necesidades particulares.',
      features: [
        'Mantenimiento de equipos industriales',
        'Calibración de instrumentos',
        'Análisis termográfico',
        'Pruebas eléctricas',
        'Certificaciones técnicas'
      ]
    }
  ];

  return (
    <div className="service-detail-page">
      <section className="service-hero">
        <div className="service-hero-content">
          <h1>Mantenimiento e Ingeniería</h1>
          <p>Soluciones técnicas integrales para la continuidad de su operación</p>
        </div>
      </section>

      <section className="service-intro">
        <div className="container">
          <div className="intro-content">
            <div className="intro-text">
              <h2>Excelencia Técnica y Operativa</h2>
              <p>
                Nuestros servicios de mantenimiento e ingeniería garantizan la continuidad operativa de 
                sus instalaciones mediante programas preventivos y correctivos diseñados específicamente 
                para cada cliente.
              </p>
              <p>
                Contamos con ingenieros y técnicos especializados, equipamiento de última generación y 
                una metodología probada que asegura la máxima disponibilidad de sus activos.
              </p>
            </div>
            <div className="intro-image">
              <img 
                src="/images/mantenimiento-principal.jpg" 
                alt="Mantenimiento e Ingeniería"
                onError={(e) => {
                  e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 400"%3E%3Crect fill="%230D3B66" width="500" height="400"/%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em" fill="white" font-size="80"%3E🔧%3C/text%3E%3C/svg%3E';
                }}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="sub-services">
        <div className="container">
          <h2>Nuestros Servicios de Mantenimiento</h2>
          <div className="sub-services-grid">
            {subServices.map((service, index) => (
              <div key={index} className="sub-service-card">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <ul>
                  {service.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="service-benefits">
        <div className="container">
          <h2>Beneficios de Nuestro Servicio</h2>
          <div className="benefits-grid">
            <div className="benefit-item">
              <div className="benefit-icon">⚙️</div>
              <h3>Máxima Disponibilidad</h3>
              <p>Reducción de tiempos de inactividad</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">💰</div>
              <h3>Reducción de Costos</h3>
              <p>Optimización de gastos operativos</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">📈</div>
              <h3>Vida Útil Extendida</h3>
              <p>Mayor durabilidad de sus activos</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">🛡️</div>
              <h3>Seguridad Garantizada</h3>
              <p>Cumplimiento normativo y certificaciones</p>
            </div>
          </div>
        </div>
      </section>

      <section className="service-cta">
        <div className="container">
          <h2>¿Necesita mantenimiento especializado?</h2>
          <p>Diseñamos el plan de mantenimiento perfecto para sus instalaciones</p>
          <div className="cta-buttons">
            <Link to="/contacto" className="btn-primary">Solicitar Cotización</Link>
            <Link to="/servicios" className="btn-secondary">Ver Todos los Servicios</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MantenimientoPage;
